import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { UiProvider } from './context/UiContext';
import MainLayout from './components/layout/MainLayout';
import LegalLayout from './components/layout/LegalLayout';
import HomePage from './components/pages/HomePage';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import LegalNotice from './components/pages/LegalNotice';
import './styles/mobile-header.css';

function App() {
  return (
    <UiProvider>
      <Router>
        <Routes>
          <Route path="/" element={
            <MainLayout>
              <HomePage />
            </MainLayout>
          } />
          <Route path="/privacy-policy" element={
            <LegalLayout>
              <PrivacyPolicy />
            </LegalLayout>
          } />
          <Route path="/legal" element={
            <LegalLayout>
              <LegalNotice />
            </LegalLayout>
          } />
        </Routes>
      </Router>
    </UiProvider>
  );
}

export default App;
